import PropTypes from 'prop-types';

import ArrowDownOutlined from '@ant-design/icons/ArrowDownOutlined';
import ArrowUpOutlined from '@ant-design/icons/ArrowUpOutlined';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import TextField from 'src/components/ui/TextField';
import IconButton from 'src/components/ui/IconButton';
import Autocomplete from 'src/components/ui/Autocomplete';
import CheckboxGroup from 'src/components/ui/CheckboxGroup';

import { FILTER_TYPE, SORT_DIRECTION } from './constants';

const FilterPlate = (props) => {
	const {
		onSubmit,
		onCancel,
		onSort,
		sortDirection,
		typeSelector,
		type,
		payload,
		withDivider,
		isError,
		isLoading,
		uiNode: uiNodeProp = null,
	} = props;

	let uiNode;

	switch (type) {
		case FILTER_TYPE.textfield:
			uiNode = <TextField {...payload} />;
			break;
		case FILTER_TYPE.checks:
			uiNode = (
				<>
					{withDivider && (
						<Box sx={{ pt: 1, pb: 0 }}>
							<Divider />
						</Box>
					)}
					<CheckboxGroup {...payload} />
				</>
			);
			break;
		default:
			uiNode = uiNodeProp;
	}

	return (
		<Card elevation={2}>
			<CardContent sx={{ p: 1.5 }}>
				<Stack spacing={1}>
					{typeSelector && <Autocomplete {...typeSelector} />}
					{uiNode}
				</Stack>
			</CardContent>
			<CardActions
				sx={{
					backgroundColor: 'background.default',
					justifyContent: 'space-between',
					borderTop: '1px solid',
					borderColor: 'divider',
				}}
			>
				{onSort && (
					<Stack direction="row">
						<IconButton
							size="small"
							disabled={isLoading}
							variant={
								sortDirection === SORT_DIRECTION.up
									? 'light'
									: 'text'
							}
							color={
								sortDirection === SORT_DIRECTION.up
									? 'primary'
									: 'secondary'
							}
							onClick={() => onSort(SORT_DIRECTION.up)}
						>
							<ArrowUpOutlined />
						</IconButton>
						<IconButton
							size="small"
							disabled={isLoading}
							variant={
								sortDirection === SORT_DIRECTION.down
									? 'light'
									: 'text'
							}
							color={
								sortDirection === SORT_DIRECTION.down
									? 'primary'
									: 'secondary'
							}
							onClick={() => onSort(SORT_DIRECTION.down)}
						>
							<ArrowDownOutlined />
						</IconButton>
					</Stack>
				)}
				<Stack direction="row" spacing={0.5}>
					{onCancel && (
						<Button
							onClick={onCancel}
							variant="text"
							size="small"
							color="secondary"
							disabled={isLoading}
						>
							Сбросить
						</Button>
					)}
					{onSubmit && (
						<Button
							disabled={!!isError || isLoading}
							onClick={() => onSubmit(isError)}
							variant="text"
							size="small"
						>
							{isLoading ? 'Загрузка…' : 'Применить'}
						</Button>
					)}
				</Stack>
			</CardActions>
		</Card>
	);
};

FilterPlate.propTypes = {
	uiNode: PropTypes.node,
	withDivider: PropTypes.bool,
	type: PropTypes.oneOf(Object.values(FILTER_TYPE)),
	typeSelector: PropTypes.shape(Autocomplete.propTypes),
	onSubmit: PropTypes.func,
	isError: PropTypes.bool,
	isLoading: PropTypes.bool,
	onCancel: PropTypes.func,
	onSort: PropTypes.func,
	sortDirection: PropTypes.oneOf(Object.values(SORT_DIRECTION)),
	payload: PropTypes.oneOfType([
		PropTypes.shape(CheckboxGroup.propTypes), // FILTER_TYPE.checks
		PropTypes.shape(TextField.propTypes), // FILTER_TYPE.textfield
	]),
};

export default FilterPlate;
